import React, { useState, useEffect } from "react";
import { auth } from "../../../../firebase/credenciales"; // Asegúrate de importar la instancia de autenticación desde tu archivo firebase.js
import "../quimicos.css";
import { Link } from "react-router-dom";

import Fondo from '../../img/BPM.jpg'
import ProductosQuimicos from "../componenteQuimico.jsx";



const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      setUser(authUser);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const descriptions = [
    { text: "Este paquete está diseñado específicamente para pequeñas y medianas empresas que necesitan una orientación integral en BPM pero con un enfoque más accesible.", customClass: "" },
    { text: <strong>• Asesoría básica para implementación de BPM</strong>, strongText: "", totalText:" (5 horas a $50/hora): $250 ", customClass: "textClass-Quimica" },
    { text: <strong>• Capacitación de personal en buenas prácticas</strong>, strongText: "", totalText:" (3 horas a $50/hora): $150", customClass: "textClass-Quimica" },
    { text: <strong>• Revisión y aprobación de etiquetas:</strong>, strongText: "", totalText: " $75", customClass: "textClass-Quimica" },
    { text: <strong>• Auditoría inicial de cumplimiento </strong>, strongText: "", totalText: " (3 horas a $115/hora): $345", customClass: "textClass-Quimica" },
    { text: <strong>• Total paquete: $820</strong>, strongText: "", totalText: "", customClass: "textClass-Quimica" },
    { text: <strong></strong>, strongText: "", totalText: "Nota: Esto es una sugerencia de paquete, podemos cotizar un servicio que se adapte a sus necesitas y que se adecue a su presupuesto", customClass: "texto-notas" }
  ];

  return (
    <ProductosQuimicos 
      backgroundImage={Fondo} 
      title="Consultoría en BPM para Pequeñas Empresas" 
      buttonText="Regencia" 
      descriptions={descriptions}
      redirectTo="/BPM"
      imgClass="imgClass-BPM"
    />
  );
};


export default App;
